import React from 'react';
import { Skeleton } from '@strivelabs/ui-core';
import { InsightsCardSkeleton } from './InsightsCardSkeleton';

export const InsightsReportSkeleton: React.FC = () => (
  <div className="w-full space-y-4">
    <InsightsCardSkeleton />
    <InsightsCardSkeleton />
    <InsightsCardSkeleton />
    <div className="rounded-lg border border-border bg-card p-4 md:p-6">
      <Skeleton className="h-4 w-64 mb-4" />
      <div className="space-y-4">
        <InsightsCardSkeleton />
        <InsightsCardSkeleton />
      </div>
    </div>
  </div>
);
